export default "__VITE_ASSET__ee6cba16__"